/* tempexp_14812-full-file */
import { BottomContent } from './BottomContent/BottomContent';

export const Albums = {
    BottomContent,
};
